<template>
    <section :class="{ 'fullscreen game': ! showReviewTab }">
        <div class="container container-lg game__inner" v-if="! showReviewTab">
            <div class="game__body game__body--info bdrs--sm bg--layer-light mt--md mb--md">
                <div class="game__info">
                    <div class="game__player game__player--first">
                        <div class="game__player__inner">
                            <div class="game__player__avatar">
                                <img :src="homePlayerAvatar" alt="" />
                            </div>

                            <div>
                                <div class="game__player__name game__player__name--max-width">{{ homePlayer }}</div>

                                <div class="game__player__score">{{ homePlayerPoints }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="game__player game__player--last">
                        <div class="game__player__inner">
                            <div class="game__player__avatar">
                                <img :src="awayPlayerAvatar" alt="" />
                            </div>

                            <div>
                                <div class="game__player__name game__player__name--max-width">{{ awayPlayer }}</div>

                                <div class="game__player__score">{{ awayPlayerPoints }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="game__body__inner">
                    <div class="profile profile--vertical profile--lg mb--20">
                        <figure class="profile__avatar">
                            <span class="profile__avatar__img">
                                <img :src="homePlayerAvatar" v-if="youWon" alt="">
                                <img :src="awayPlayerAvatar" v-else alt="">
                            </span>
                        </figure>

                        <div class="profile__text">
                            <div class="profile__name" v-if="youWon">You Won!</div>

                            <p v-else>
                                <slot name="gameEndTextLosingPlayer">Ooh, that was close.</slot>
                            </p>

                            <div class="game__question" v-if="speedBonus">Speed bonus: +{{ speedBonus }} points</div>
                            <div class="game__question" v-if="perfectGameBonus">Perfect game bonus: +{{ perfectGameBonus }} points</div>
                        </div>
                    </div>

                    <div class="row mb--lg">
                        <div class="col-5 offset-1">
                            <div class="icon-value justify-content--center">
                                <img src="/img/icons/xp.png" alt=""> +{{ homePlayerXp}} XP
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="icon-value justify-content--center">
                                <img src="/img/icons/coin.png" alt=""> +0 Quids
                            </div>
                        </div>
                    </div>

                    <div class="text--center">
                        <button @click="showReviewTab = true" class="btn btn--sm btn--white">Review mistakes</button>
                        <button v-if="showHelp" @click="askForHelp" class="btn btn--sm btn--white">Ask for help</button>
                    </div>
                </div>
            </div>

            <div class="game__footer">
                <slot>
                    <router-link to="/" class="btn btn--action btn--white mb--sm">Go to home</router-link>
                </slot>
            </div>
        </div>
        <div v-if="showReviewTab" class="container animated backInUp">
            <header class="header">
                <div class="container">
                    <div class="row align-items--center">
                        <div class="col-8 offset-2">
                            <h1 class="header__title">Review mistakes</h1>
                        </div>

                        <div class="col-2 text--right">
                            <button @click="showReviewTab = false" class="btn btn--icon btn--white"><i class="material-icons">close</i></button>
                        </div>
                    </div>
                </div>
            </header>

            <div v-for="question in questions" class="panel bg--layer-darker pt--20 pb--20 mb--md">
                <div class="text--lg mb--10"><strong>{{ question.question.question }}</strong></div>
                <div class="c--success text--sm mb--sm text--review"><i class="material-icons">check</i>
                    <strong>{{ question.good_answer.answer }}</strong>
                </div>
                <div class="c--danger text--sm mb--0 text--review"><i class="material-icons">close</i>
                    <strong v-if="question.bad_answer">{{ question.bad_answer.answer }}</strong>
                    <div class="profile__avatar"><span class="profile__avatar__img">
                        <img :src="avatar" alt=""></span></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import api from "../../../api/gameReview";
import multiplayerApi from "../../../api/multiplayer"

export default {
    props: {
        youWon: {
            default: false,
            type: Boolean
        },

        homePlayer: {
            required: true,
            type: String
        },

        homePlayerAvatar: {
            required: true,
            type: String
        },

        homePlayerPoints: {
            required: false,
            type: Number,
            default: 0
        },

        homePlayerXp: {
            required: false,
            type: Number,
            default: 0
        },

        awayPlayer: {
            required: true,
            type: String
        },

        awayPlayerAvatar: {
            required: true,
            type: String
        },

        awayPlayerPoints: {
            required: false,
            type: Number,
            default: 0
        },

        speedBonus: {
            required: false,
            default: 0,
            type: Number
        },

        perfectGameBonus: {
            required: false,
            default: 0,
            type: Number
        },

        review: {
            required: false,
            default: null,
            type: Object
        },

        showReview: {
            required: false,
            default: true,
            type: Boolean
        },

        showHelp: {
            required: false,
            default: false,
            type: Boolean
        },

        quizId: {
            required: false,
            default: null,
            type: String
        }
    },

    data: function () {
        return {
            showReviewTab: false,
            questions: null
        }
    },

    watch: {
        showReviewTab: function () {
            if (this.showReviewTab) {
                this.loadQuestions()
            }
        }
    },

    methods: {
        loadQuestions() {
            if (! this.quizId) {
                return
            }

            api.getQuestions(this.quizId).then((response) => {
                this.questions = response.data
            })
        },

        askForHelp() {
            multiplayerApi.askForHelp(this.quizId)
                .then((response) => this.$router.push('/chat/' + response.data.data.id))
        }
    }
}
</script>
